import { cloneElement, createElement, isValidElement } from 'react';
import RectShape from "../shapes/Rect.js";
import CircleShape from "../shapes/Circle.js";
import LineShape from "../shapes/Line.js";
const NO_OP = () => undefined;
export default function renderShape(_ref) {
  let {
    shape = 'rect',
    fill = NO_OP,
    size = NO_OP,
    width,
    height,
    label,
    item,
    itemIndex,
    shapeStyle = NO_OP
  } = _ref;
  const props = {
    width,
    height,
    item,
    itemIndex,
    label,
    fill: fill({
      ...label
    }),
    size: size({
      ...label
    }),
    style: shapeStyle({
      ...label
    })
  };
  if (typeof shape === 'string') {
    if (shape === 'circle') {
      return /*#__PURE__*/createElement(CircleShape, props);
    }
    if (shape === 'line') {
      return /*#__PURE__*/createElement(LineShape, props);
    }
    return /*#__PURE__*/createElement(RectShape, props);
  }
  if (/*#__PURE__*/isValidElement(shape)) {
    return /*#__PURE__*/cloneElement(shape, props);
  }
  if (shape) {
    return /*#__PURE__*/createElement(shape, props);
  }
  return null;
}